export default {
  props: {
    color: {
      type: String,
      default: '#409bff'
    }
  },
  render (h) {
    return (
      <van-loading class="list-view-loadmore" color={this.color} style={{width: 24, height: 24}} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/list-view/circular.js